
export default {
  data() {
    return {
      searchQuery: "",
      showLoader: false,
      searchResults: null,
      selectedAddress: null,
    };
  },

  watch: {
    searchQuery(newVal) {
      if (newVal === "") {
        this.removeAddressSelection();
      }
    },
  },

  methods: {
    async getSearchResutls() {
      try {
        this.showLoader = true;
        if (!this.searchQuery) return;
        const data = await this.$axios.get(
          `https://api.unikom.hr/api/unikom/planOdvozaOpen/address?address=${this.searchQuery}`
        );

        if (data && data.data && data.data.length) {
          this.searchResults = data.data;
        } else {
          this.$toast.error(this.$t("toast.noResults"));
        }

        setTimeout(() => {
          this.showLoader = false;
        }, 300);
      } catch (err) {
        console.log(err);
        this.showLoader = false;
      }
    },

    selectAddress(address = null) {
      this.selectedAddress = address;
      this.$emit("selected-address", address);
    },

    searchKeyword() {
      this.debounce(this.getSearchResutls);
    },

    removeAddressSelection() {
      this.searchQuery = "";
      this.searchResults = [];

      this.selectAddress();
      this.$emit("remove-selection");

      setTimeout(() => {
        this.showLoader = false;
      }, 300);
    },
  },
};
